import angular from 'angular';

export const SUPPRESSED_DEFINITIONS = [706, 930, 1018, 1020, 1024, 1029, 1030, 1031, 1032, 1067, 1068,
    1077, 1080];

/**
 * Created by Won on 8/12/2016.
 */
/* @ngInject */
export default function UniquePartModelService(DocFinderFileService, ParameterApiService, $translate, __env) {
    let compareQueue = [];
    let fauxUniquePart = {};
    fauxUniquePart.type = 'detectedFromSearch';

    return {
        getFauxUniquePartObj: function () {
            fauxUniquePart = {};
            fauxUniquePart.type = 'detectedFromSearch';
            return fauxUniquePart;
        },
        getCompareQueue: function () {
            return compareQueue;
        },
        copyCompareQueue: function () {
            var results = [];
            angular.forEach(compareQueue, function (value) {
                results.push(value);
            });
            return results;
        },
        clearCompareQueue: function () {
            angular.forEach(compareQueue, function (value) {
                if (value.isClicked) {
                    value.isClicked = false;
                }
            });
            compareQueue.length = 0;
        },

        /**
         * Remove a part from comparison
         * @param uniquePart
         */
        removeComparison: function (uniquePart) {
            if (uniquePart.isClicked !== undefined && uniquePart.isClicked === true) {
                uniquePart.isClicked = !uniquePart.isClicked;
                //de-incrementing, so that when it reaches -1 it evals to false and stops the loop.
                for (var i = compareQueue.length - 1; i >= 0; i--) {
                    if (compareQueue[i].uniquePn === uniquePart.uniquePn) {
                        compareQueue.splice(i, 1);
                    }
                }
            }
        },

        /**
         * Add a part to the comparison queue
         * @param uniquePart
         */
        addComparison: function (uniquePart) {
            uniquePart.isClicked = true;
            if (uniquePart.name === undefined) {
                uniquePart.name = uniquePart.displayPn;
            }
            compareQueue.push(uniquePart);
        },

        /**
         * Check the comparison queue
         * @uses removeComparison(), addComparison()
         * @param uniquePart
         * @return {*}
         */
        updateComparison: function (uniquePart) {
            if (compareQueue.length >= 3 && !uniquePart.isClicked) {
                uniquePart.isClicked = false;
                return $translate.instant('message__overSelection').valueOf();
            }

            if (uniquePart.isClicked) {
                this.removeComparison(uniquePart);
            } else {
                this.addComparison(uniquePart);
            }
            return null;
        },
        /**
         * Set the Specsheet URL depending on if it's a special case.
         * @param {Array} definitions - the ancestral definitions.
         * @param {Object} uniquePart - the Unique Part object to set the Specsheet URL on.
         */
        setSpecUrl: function (definitions, uniquePart) {
            const matchedDefinitions = definitions.filter( (def) => SUPPRESSED_DEFINITIONS.includes(def.id) )

            // No triple equals here, because it can return 'undefined'
            if (matchedDefinitions.length == 0) {
                uniquePart.specUrl = DocFinderFileService.buildIntelliSpecUrl( uniquePart.uniquePn );
            } else {
                uniquePart.specUrl = DocFinderFileService.buildDataSheetUrl(uniquePart);
            }
        },
        /**
         * Set the IntelliSpec Pro URL depending on if it's a special case.
         * @param {Array} definitions - the ancestral definitions.
         * @param {Object} uniquePart - the Unique Part object to set the Specsheet URL on.
         */
        setSpecProUrl: function ( definitions, uniquePart ) {
            const matchedDefinitions = definitions.filter( (def) => SUPPRESSED_DEFINITIONS.includes(def.id) )
            // No triple equals here, because it can return 'undefined'
            if (matchedDefinitions.length == 0) {
                uniquePart.specProUrl = DocFinderFileService.buildIntelliSpecProUrl( uniquePart.uniquePn );
            } else {
                uniquePart.specProUrl = DocFinderFileService.buildDataSheetUrl( uniquePart );
            }
        },
        setObsoleteMessage: function (uniquePart) {
            if (uniquePart.obsoleteDate != null) {
                uniquePart.obsoleteMessage = '';
                if (new Date(uniquePart.obsoleteDate).getTime() > new Date().getTime()) {
                    $translate('message__obsolete__nnd').then(function (obsoleteMessage) {
                        uniquePart.obsoleteMessage = obsoleteMessage.valueOf();
                    });
                } else {
                    $translate('message__obsolete').then(function (obsoleteMessage) {
                        uniquePart.obsoleteMessage = obsoleteMessage.valueOf();
                    });
                }
            }
        },
        getAlternativeParts: function (uniquePart, successCallBack) {
            // parameterValues.push(uniquePart.series);
            ParameterApiService.getParametersByDefinitionAndAlternateQuery(uniquePart.leafDefinitionId, function (parameters) {
                var parameterValues = [];
                var parameterIds = [];
                parameters.forEach(function (parameter) {
                    parameterIds.push(parameter.id);
                });
                for (var i = 0; i < uniquePart.parameterValues.length; ++i) {
                    for (var j = 0; j < parameterIds.length; ++j) {
                        if (parameterIds[j] == uniquePart.parameterValues[i].parameterId) {
                            parameterValues.push(uniquePart.parameterValues[i]);
                            break;
                        }
                    }
                }
                successCallBack(parameterValues);
            });
            // In case user want to get alternative parts by sleuthData in future
            //
            // if(sleuthData) {
            //     var hasSeries = false;
            //     for(i=0;i<sleuthData.detectedParameterValues.length;++i) {
            //         if(sleuthData.detectedParameterValues[i].parameterId == 3) {
            //             hasSeries = true;
            //         }
            //         parameterValues.push(sleuthData.detectedParameterValues[i]);
            //     }
            //     if(!hasSeries) {
            //         parameterValues.push(uniquePart.series);
            //     }
            //     getAlternatepartBySleuthAndHandleUI([uniquePart.leafDefinitionId], parameterValues, successCallBack)
            // } else {
            //
            //     parameterValues.push(uniquePart.series);
            //     ParameterApiService.getParametersByDefinitionAndLimiting(uniquePart.leafDefinitionId, function(parameters) {
            //         var parameterIds = [];
            //         parameters.forEach(function(parameter) {
            //             parameterIds.push(parameter.id);
            //         });
            //         for(var i=0;i<uniquePart.parameterValues.length;++i) {
            //             for(var j=0;j<parameterIds.length;++j) {
            //                 if(parameterIds[j] == uniquePart.parameterValues[i].parameterId) {
            //                     parameterValues.push(uniquePart.parameterValues[i]);
            //                     break;
            //                 }
            //             }
            //         }
            //         getAlternatepartBySleuthAndHandleUI([uniquePart.leafDefinitionId], parameterValues, successCallBack)
            //     });
            // }
        }
    };
}
